import RestartAltIcon from "@mui/icons-material/RestartAlt";
import { Button, Tooltip } from "@mui/material";

interface Props {
	onClick: () => void;
	disabled?: boolean;
	tooltip?: string;
}

// Filled primary, medium, the same height as ExcelButton. The
// dense margin matches the mesf-core TextFields so it sits on their centre line.
export const ResetFiltersButton = ({
	onClick,
	disabled,
	tooltip = "Reset filters",
}: Props) => (
	<Tooltip title={tooltip}>
		<span>
			<Button
				size="medium"
				variant="contained"
				color="primary"
				onClick={() => onClick()}
				disabled={disabled}
				startIcon={<RestartAltIcon />}
				sx={{
					mt: 1,
					mb: 0.5,
					whiteSpace: "nowrap",
					// The arrow head sits above the ring, so centring the glyph box leaves the
					// ring 1 to 2 px below the caps centre, depending on the zoom; 1.5 keeps it
					// within half a pixel at 80 % and at 100 %.
					"& .MuiButton-startIcon svg": { transform: "translateY(-1.5px)" },
				}}
			>
				RESET
			</Button>
		</span>
	</Tooltip>
);
